import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-gray-50 border-b">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <Link to="/" className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-4">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">Terms of Service</h1>
          <p className="text-gray-600 mt-2">Last updated: January 2026</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="space-y-8">
  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">
      1. About MealGuide
    </h2>
    <p className="text-gray-600 mb-3">
      MealGuide is a subscription-based meal planning service designed to provide
      structured meal plans for weight management. By creating an account or
      using the service, you agree to these Terms of Service.
    </p>
  </section>

  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">
      2. Not Medical Advice
    </h2>
    <p className="text-gray-600 mb-3">
      MealGuide provides meal planning and nutrition guidance for general
      information purposes only. It does not provide medical advice and is not a
      substitute for professional medical guidance. If you have a medical
      condition, dietary restriction, or concerns, consult a qualified
      professional before making changes to your diet.
    </p>
  </section>

  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">
      3. User Responsibility
    </h2>
    <p className="text-gray-600 mb-3">
      You are responsible for how you use MealGuide and for ensuring the meal
      plan fits your personal needs, preferences, allergies, and health
      circumstances. You are also responsible for safe food preparation and
      storage.
    </p>
  </section>

  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">
      4. No Guaranteed Results
    </h2>
    <p className="text-gray-600 mb-3">
      MealGuide does not guarantee weight loss or specific outcomes. Results
      vary based on individual factors and adherence over time.
    </p>
  </section>

  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">
      5. Subscription, Trial, and Billing
    </h2>
    <p className="text-gray-600 mb-3">
      MealGuide is billed on a recurring monthly basis at <strong>£27/month</strong>{" "}
      unless cancelled.
    </p>
    <ul className="list-disc list-inside text-gray-600 space-y-1">
      <li>
        <strong>7-day free trial:</strong> A valid payment method is required to
        start the trial.
      </li>
      <li>
        Unless cancelled before the end of the trial, your subscription
        automatically converts to a paid plan.
      </li>
      <li>
        You can cancel at any time from your account billing settings. After
        cancellation, you keep access until the end of your current billing
        period.
      </li>
    </ul>
  </section>

  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">
      6. Account Use
    </h2>
    <p className="text-gray-600 mb-3">
      MealGuide is intended for personal, non-commercial use only. You agree not
      to misuse the service, attempt to disrupt it, or use it in a way that
      violates applicable laws.
    </p>
  </section>

  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">
      7. Service Changes
    </h2>
    <p className="text-gray-600 mb-3">
      MealGuide may update, modify, or discontinue parts of the service over
      time to improve functionality, maintain the product, or address technical
      requirements.
    </p>
  </section>

  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">
      8. Limitation of Liability
    </h2>
    <p className="text-gray-600 mb-3">
      MealGuide is provided “as is” without warranties of any kind. To the
      fullest extent permitted by law, MealGuide is not liable for indirect,
      incidental, or consequential damages arising from your use of the service.
    </p>
  </section>

  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">
      9. Contact
    </h2>
    <p className="text-gray-600 mb-3">
      Questions about these Terms can be sent to:
    </p>
    <p className="text-gray-600 mb-3">
      <strong>support@getmealguide.com</strong>
    </p>
  </section>
</div>

      </div>

      {/* Footer */}
      <footer className="bg-gray-50 border-t mt-12">
        <div className="max-w-4xl mx-auto px-4 py-6 text-center text-gray-600">
          © 2026 MealGuide. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
